// import React from "react";
// import Chart from "react-apexcharts";

// const DISPOSITION_COLORS = {
//   "interested": "#28a745",
//   "contacted": "#ffc107",
//   "proposal sent": "#17a2b8",
//   "converted": "#00E396",
//   "not interested": "#dc3545",
//   "denied by us": "#ff0000",
//   "wrong no": "#6c757d",
//   "did not pick up": "#343a40",
//   "escalated to admin": "#800080",
//   "others": "#d3d3d3",
// };

// const LastChart = ({ data = [] }) => {
//   // Backend data: [{ label: "interested", value: 5 }, ...]
//   const labels = data.map((item) => item.label);
//   const series = data.map((item) => item.value);
//   const colors = labels.map((l) => DISPOSITION_COLORS[l.toLowerCase()] || "#cccccc");

//   const options = {
//     chart: { type: "pie" },
//     labels: labels.map(l => l.toUpperCase()),
//     colors: colors,
//     legend: { position: "bottom" },
//     dataLabels: {
//       enabled: true,
//       formatter: (val) => `${val.toFixed(1)}%`,
//     },
//     tooltip: {
//       y: { formatter: (val) => `${val} Leads` }
//     }
//   };

//   return (
//     <div className="card-body text-center">
//       <h5 className="card-title mb-3">Leads by Status</h5>
//       {series.length > 0 ? (
//         <Chart options={options} series={series} type="pie" height={320} />
//       ) : (
//         <div className="p-5 text-muted">No status data available</div>
//       )}
//     </div>
//   );
// };

// export default LastChart;

import React from "react";
import Chart from "react-apexcharts";

const DISPOSITION_COLORS = {
  pending: "#FEB019",
  in_progress: "#00B8D9",
  testing: "#775DD0",
  completed: "#00E396",

  interested: "#28a745",
  contacted: "#ffc107",
  "proposal sent": "#17a2b8",
  converted: "#00E396",
  "not interested": "#dc3545",
  others: "#d3d3d3",
};

const LastChart = ({ data = [], title = "Status Chart" }) => {
  const labels = data.map((item) => item?.label || "OTHERS");
  const series = data.map((item) => item?.value || 0);

  const colors = labels.map((l) => {
    const key = l ? l.toString().toLowerCase() : "others";
    return DISPOSITION_COLORS[key] || "#cccccc";
  });

  const options = {
    chart: { type: "pie" },
    labels: labels.map((l) => (l ? l.toString().toUpperCase() : "OTHERS")),
    colors: colors,
    legend: { position: "bottom" },
    dataLabels: {
      enabled: true,
      formatter: (val) => `${val.toFixed(1)}%`,
    },
    tooltip: {
      y: { formatter: (val) => `${val} Leads` },
    },
  };

  return (
    <div className="card-body text-center">
      <h5 className="card-title mb-3">{title}</h5>{" "}
      {series.some((x) => x > 0) && series.some((v) => v > 0) ? (
        <Chart options={options} series={series} type="pie" height={320} />
      ) : (
        <div className="p-5 text-muted">No status data available</div>
      )}
    </div>
  );
};

export default LastChart;
